import { useQuery } from "@tanstack/react-query";
import { BookingSettingsDto } from "../types/ageOccupationRule";

async function fetchBookingSettings(): Promise<BookingSettingsDto> {
  const res = await fetch("/age-occupation-rules.json", {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });

  if (!res.ok) {
    throw new Error("Không tải được cấu hình booking.");
  }

  const data = (await res.json()) as Partial<BookingSettingsDto>;

  return {
    ageToOccupationRules: Array.isArray(data.ageToOccupationRules)
      ? data.ageToOccupationRules
      : [],
  };
}

export function useBookingSettings() {
  return useQuery({
    queryKey: ["booking-settings"],
    queryFn: fetchBookingSettings,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: "always",
  });
}